<template>
    <td-dialog :title="$t(title)" :before-close="cancel" :visible.sync="dialogSmsVisible" width="350px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formInfo" ref="formInfo" :rules="rules" label-position="right" label-width="80px">
            <el-form-item :label="$t('common.TEMPLATE_SIGN')" prop="sSign">
                <td-input v-model="formInfo.sSign" :disabled="readonly" maxlength="12"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.TEMPLATENAME')" prop="sName">
                <td-input v-model="formInfo.sName" maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.TEMPLATE_TYPE')" prop="sType">
                <td-select v-model="formInfo.sType" :options="templateTypes" keys="id" text="name"></td-select>
            </el-form-item>
            <el-form-item :label="$t('common.TEMPLATE_PARAMETER_ENGINE')" prop="sParamEngine">
                <td-input v-model="formInfo.sParamEngine" maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.TEMPLATE_CONTENT')" prop="sContent">
                <td-input v-model="formInfo.sContent" type="textarea" maxlength="2000"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';

export default {
    props: {
        title: {},
        dialogSmsVisible: {},
        editItem: {
            type: Object
        },
        templateTypes: {
            // type: Array
        }
    },
    created() {
        // 为编辑状态则进行初始化数据
        if (this.editItem.sId) {
            this.initEditData();
        }
    },
    // 定义变量
    data: function() {
        return {
            readonly: false,
            // 短信模板表单信息
            formInfo: {
                sId: '',
                sName: '',
                sSign: '',
                sType: '',
                sParamEngine: '',
                sContent: ''
            },
            saveLoading: false,
            // 对表单进行数据验证
            rules: {
                sSign: [
                    { required: true, message: this.$t('error.ERROR_TEMPLATE_SIGN'), trigger: 'blur' },
                    { pattern: '^[A-Za-z0-9_]+$', message: this.$t('pgRegex.ONLY_ENGLISH_NUM_UNDERLINE') },
                    {
                        validator: this.checkRepeat,
                        trigger: 'blur'
                    }
                ],
                sName: [
                    {
                        required: true,
                        message: this.$t('pgError.ERROR_TEMPLATE_CAPTION_IS_NULL'),
                        trigger: 'blur'
                    },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                sType: [{ required: true, message: this.$t('error.ERROR_TEMPLATE_TYPE'), trigger: 'change' }],
                sParamEngine: [{ pattern: '^[A-Za-z0-9_]+$', message: this.$t('pgRegex.ONLY_ENGLISH_NUM_UNDERLINE') }],
                sContent: [{ required: true, message: this.$t('error.ERROR_TEMPLATE_CONTENT'), trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.readonly = true;
            this.formInfo.sId = this.editItem.sId;
            this.formInfo.sName = this.editItem.sName;
            this.formInfo.sSign = this.editItem.sSign;
            this.formInfo.sType = this.editItem.sType;
            this.formInfo.sParamEngine = this.editItem.sParamEngine;
            this.formInfo.sContent = this.editItem.sContent;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.saveLoading = true;
                    api.saveSmsTemplate(this.formInfo, response => {
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('smsTemplate/addSmsTemplate', response.data.statusMessage);
                            this.saveLoading = false;
                            return;
                        }
                        this.saveLoading = false;
                        let message = this.$t('common.ADD_SUCCESS');
                        if (this.formInfo.sId) {
                            message = this.$t('common.MODIFY_SUCCESS');
                        }
                        this.$message({ showClose: true, message: message, type: 'success' });
                        this.SmsDialogClose();
                    });
                }
            });
        },
        // 取消
        cancel() {
            this.$emit('SmsDialogClose');
            this.$refs['formInfo'].resetFields(); // 重置表单数据
            this.formInfo = {};
        },
        // 关闭窗口之前需要调用的方法
        SmsDialogClose() {
            this.cancel();
            this.$emit('submit');
        },
        checkRepeat(rule, value, callback) {
            if (!this.formInfo.sId || this.formInfo.sId !== '') {
                callback();
            } else {
                let param = {
                    sSign: value
                };
                api.checkRepeat(param, response => {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content.repeat) {
                            callback(this.$t('error.ERROR_TEMPLATE_SIGN_REPEAT'));
                        } else {
                            callback();
                        }
                        this.saveLoading = false;
                        return;
                    } else {
                        callback();
                    }
                });
            }
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}

.el-dialog__header {
    background-color: rgb(30, 160, 255);
}

.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
